import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { Page, Loading, Ooops } from 'components';
import {
  Header,
  Total,
  Overview,
  ChargeAndLinkPay,
  Transfer,
  EarningsSegmentation
} from './components';
import {
  AuthCheckJWT,
  GetCompany,
  GetBranch,
  GetDashboard,
  DashboardResetYear
} from 'store/actions';
import { makeStyles } from '@material-ui/styles';

const Dashboard = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const authen = useSelector(({ authen }) => authen);
  const dashboard = useSelector(({ dashboard }) => dashboard);
  const companySelect = useSelector(({ company }) => company.select);

  const [pageInit, setPageInit] = useState(false);

  useEffect(() => {
    dispatch(AuthCheckJWT('/dashboard'));
  }, [dispatch]);

  useEffect(() => {
    const superFetchData = async () => {
      await dispatch(GetCompany());
      await dispatch(GetBranch());
      await dispatch(GetDashboard());
      setPageInit(true);
    };

    const adminFetchData2 = async () => {
      await dispatch(GetBranch());
      await dispatch(GetDashboard());
      setPageInit(true);
    };

    if (authen.isAuthenticated) {
      if (authen.loginUser.role === 'super') {
        superFetchData();
      } else {
        adminFetchData2();
      }
    }
  }, [dispatch, authen]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(GetBranch());
      await dispatch(DashboardResetYear());
      await dispatch(GetDashboard());
    };

    if (pageInit) fetchData();
  }, [dispatch, companySelect]);

  if (dashboard.isFetching) {
    return <Loading title="Dashboard" />;
  }

  if (dashboard.isError) {
    return <Ooops title="Dashboard" />;
  }

  return (
    <Page
      className={classes.root}
      title="Dashboard"
    >
      {pageInit && (
                <>
                    <Header />
                    <Grid
                      className={classes.container}
                      container
                      spacing={3}
                    >
                      <Grid
                        item
                        lg={12}
                        xs={12}
                      >
                        <Total />
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        xs={12}
                      >
                        <Overview />
                      </Grid>

                      <Grid
                        item
                        lg={8}
                        xs={12}
                      >
                        <ChargeAndLinkPay />
                      </Grid>

                      <Grid
                        item
                        lg={4}
                        xs={12}
                      >
                        <EarningsSegmentation />
                      </Grid>

                      <Grid
                        item
                        lg={12}
                        xs={12}
                      >
                        {/* <Transfer /> */}
                      </Grid>
                    </Grid>
                </>
      )}
    </Page>
  );
};

export default Dashboard;

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  container: {
    marginTop: theme.spacing(0)
  }
}));
